import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canAccessRoute, getDefaultRoute } from "@/lib/permissions";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8]">
        <div className="text-sm text-[#666] font-mono">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!canAccessRoute(user, location.pathname)) {
    return <Navigate to={getDefaultRoute(user)} replace />;
  }
  return children;
}
